<script>
import Layout from '@layouts/main.vue'

// import axios from 'axios'

import { getFlightConfig } from '@utils/helpers.js'

import moment from 'moment'

import SeatMapWrapper from '@components/flight/SeatMapWrapper.vue'
import SeatMapKey from '@components/flight/SeatMapKey.vue'

export default {
  page() {
    return {
      title: this.user.name,
      meta: [
        {
          name: 'description',
          content: `Graphical seat map.`,
        },
      ],
    }
  },
  components: { Layout, SeatMapWrapper, SeatMapKey },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showBays: true,
      showAttributes: false,
      seatmapData: [],
      lastUpdated: [{ type: 'seatmaplist', timestamp: null }],
      isLoading: false,
      sideBarVisible: true,
      flightId: null,
    }
  },
  computed: {
    flight() {
      return this.$store.getters['flights/getFlightById'](this.flightId)
    },
  },
  watch: {
    '$route.params.flightId': {
      immediate: true,
      handler(flightId) {
        this.flightId = flightId
      },
    },
  },
  beforeMount() {
    if (!this.flight) {
      this.$router.push('/flights')
    }
  },
  mounted() {
    // this.getData()
  },
  methods: {
    getFlightConfig: getFlightConfig,
    moment(date, format) {
      return moment(date).format(format)
    },
  },
}
</script>

<template>
  <Layout id="seatmap" :last-updated="lastUpdated">
    <div class="content-container">
      <div v-if="sideBarVisible" id="sidebar-collapse" class="sidebar collapse">
        <div class="sidebar-content container">
          <div class="app-sidebar text-small">
            <div class="app-sidebar-top text-left">
              <button
                class="btn btn-primary btn-block"
                @click="showBays = !showBays"
              >{{ !showBays ? 'Show Bays' : 'Hide Bays' }}</button>

              <button
                class="btn btn-primary btn-block"
                @click="showAttributes = !showAttributes"
              >{{ !showAttributes ? 'Show Attributes' : 'Hide Attributes' }}</button>

              <!-- <p class>
                <span class="text-lg">
                  {{ flight.FlightNumber }}/{{
                  moment(flight.Std, 'DDMMM').toUpperCase()
                  }}
                </span>
                <br />
                ROUTING {{ flight.Destinations }}
                <br />
                EQP {{ flight.Equipment }} {{ flight.Registration }}
                {{ getFlightConfig(flight) }}
                <br />
                {{ flight.Etd ? 'STD/ETD' : 'STD' }}
                {{ moment(flight.Std, 'HH:mm') }} {{ flight.Etd ? '/' : '' }}
                {{ flight.Etd ? moment(flight.Etd, 'HH:mm') : '' }}
                <br />STATUS
                <span
                  class="flight-status"
                  :class="flight.FlightStatus.toLowerCase()"
                >{{ flight.FlightStatus }}</span>
              </p>-->
              <div class="mt-5">
                <h5>Seat Map Key</h5>
                <SeatMapKey style="text-align: left" />
              </div>
            </div>
          </div>

          <div class="app-sidebar-bottom">
            <div class="container"></div>
          </div>
        </div>
      </div>
      <div class="row w-100">
        <div class="col-xl-12">
          <SeatMapWrapper :show-bays="showBays" :show-attributes="showAttributes" />
        </div>
        <div class="col-xl-2"></div>
      </div>
    </div>
  </Layout>
</template>

<style>
.scrollable-seatmap {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  margin: auto;
}
</style>
